//#region imports
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription, forkJoin, map, of, skip, switchMap, take } from 'rxjs';
import { ConfigService } from 'src/app/services/app.config.service';
import { AppConfig } from 'src/app/domain/appconfig';
import { AppBreadcrumbService } from 'src/app/services/app.breadcrumb.service';
import { CustomerService, UpdateCustomer } from 'src/app/services/customer.service';
import { ConfirmEventType, ConfirmationService, MessageService } from 'primeng/api';
import { AddCustomerAddress, CreateCustomer, Customer, CustomerAddress, CustomerContact } from 'src/app/domain/Customer';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { atLeastOne } from 'src/app/pages/Shared/directives/atLeastOneValidator';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddressDialogComponent } from '../Shared/dialogs/address-dialog/address-dialog.component';
import { CustomerDialogComponent } from '../Shared/dialogs/customer-dialog/customer-dialog.component';
import { ContactDialogComponent } from '../Shared/dialogs/contact-dialog/contact-dialog.component';
import { AuthService, OBPermisssionsLocal } from 'src/app/services/auth.service';
import { Address } from 'src/app/domain/Address';
import { AddressService } from 'src/app/services/address.service';
import { ImportCustomerDialogComponent } from './import-customer-dialog/import-customer-dialog.component';
import { ClientService } from 'src/app/services/client.service';
import { Service } from 'src/app/domain/Service';
//#endregion
@Component({
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
  providers: [DialogService],
})
export class CustomersComponent implements OnInit, OnDestroy {
  transitionOption: string = '250ms cubic-bezier(0, 0, 0.2, 1)';
  config: AppConfig;
  subscription: Subscription;
  customers = this.customerService.Customers$.pipe(
    map(customers =>
      customers.map(customer => ({
        ...customer,

        addressSearch: (customer.customerAddrses ?? [])
          .map(address =>
            `${address.street ?? ''} ${address.zipCode ?? ''} ${address.city ?? ''} ${address.countryCode ?? ''}`
          )
          .join(' ')
      }))
    )
  );
  customer: Customer;
  selectedCustomers = new Array<Customer>();

  tmpCustomerNo: string;
  tmpCustomerName: string;
  tmpCustomerNote: string;
  tmpCustomerServiceCodes: string[];

  displayNewCustomerDialog = false;
  displayAddAddressDialog = false;
  displayAddContactDialog = false;
  displayImportDialog = false;

  selectedAddresses: any[];
  selectedContactPersons: any[];

  ref: DynamicDialogRef;

  loading: boolean = false;
  fullPageLoading: boolean = false;
  addressesLoading: boolean = true;
  createCustomerPermission = OBPermisssionsLocal.CreateCustomer;
  clientServices: Service[] = new Array<Service>();

  newCustomerForm = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    customerNo: new FormControl(null),
    registrationNumber: new FormControl(null),
    countryCode: new FormControl(null, [Validators.required]),
    street: new FormControl(null, [Validators.required]),
    street2: new FormControl(),
    zipCode: new FormControl(null, [Validators.required]),
    city: new FormControl(null, [Validators.required]),
    longitude: new FormControl(0),
    latitude: new FormControl(0),
    validatedBy: new FormControl(null),
    contactName: new FormControl(null),
    contactEmail: new FormControl(null, [
      Validators.email,
      Validators.pattern(
        /^[A-Za-z0-9!#$%&amp;'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&amp;'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/
      ),
    ]),
    contactPhone: new FormControl(null),
    sendLabel: new FormControl({ value: null, disabled: true }),
    note: new FormControl(null),
    serviceCodes: new FormControl(new Array<string>())
  });

  newAddressForm = new FormGroup({
    id: new FormControl(null),
    countryCode: new FormControl(null, [Validators.required]),
    street: new FormControl(null, [Validators.required]),
    street2: new FormControl(),
    zipCode: new FormControl(null, [Validators.required]),
    city: new FormControl(null, [Validators.required]),
    longitude: new FormControl(0),
    latitude: new FormControl(0),
  });
  newContactForm = new FormGroup(
    {
      id: new FormControl(null),
      default: new FormControl(false),
      name: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [
        Validators.email,
        Validators.pattern(
          /^[A-Za-z0-9!#$%&amp;'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&amp;'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/
        ),
      ]),
      phone: new FormControl(null),
      sendLabel: new FormControl({ value: null, disabled: true }),
    },
    { validators: [atLeastOne(Validators.required, ['email', 'phone'])] }
  );

  customerBreadcrumbDefinition = {
    label: this.translateService.instant('ROUTES.CUSTOMERS'),
    command: () => {
      this.customer = null;
      this.breadcrumbService.setItems([
        {
          label: this.translateService.instant('ROUTES.CUSTOMERS'),
          routerLink: ['customers'],
        },
      ]);
    },
  };

  //#region DOM Events
  // got this to work, turns out the ide was to remove the view when clicking on esc, however this dont makes seans since the only thing you want to see there is the infomation from that customer.
  // so there is no reason to "remove" that view. there are no other things to show there any way.
  // @HostListener('document:keydown.escape', ['$event']) onKeydownEscapeHandler(event: KeyboardEvent) {
  //   if (!this.displayNewCustomerDialog && !this.displayAddAddressDialog && !this.displayAddContactDialog) {
  //     this.clearChoice();
  //   }
  // }
  //#endregion

  constructor(
    private breadcrumbService: AppBreadcrumbService,
    private configService: ConfigService,
    private customerService: CustomerService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService,
    private address: AddressService,
    public dialogService: DialogService,
    public authService: AuthService,
    private clientService: ClientService
  ) {
    this.breadcrumbService.setItems([
      {
        label: translateService.instant('ROUTES.CUSTOMERS'),
        routerLink: ['customers'],
      },
    ]);
    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe((config) => {
      this.config = config;
    });
  }

  ngOnInit() {
    this.loadCustomers();
    this.clientService.clientServices$.subscribe(x => this.clientServices = x)
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.ref) {
      this.ref.close();
    }
  }
  //#region GuiFunctions
  // not in used any more
  onRowSelect(event: any) {
    if (event.type === 'checkbox')
      return;

    this.customer = event.data;
    this.tmpCustomerName = event.data.name;
    this.tmpCustomerNo = event.data.customerNo;
    this.tmpCustomerNote = event.data.note;

    if (this.customer.addresses?.length)
      this.addressesLoading = false;
    else {
      this.customer.addresses = [];
      this.addressesLoading = true;
      let addressIds = event.data.addressIds ?? [];
      if (addressIds.length === 0)
        this.addressesLoading = false;
      else {
        let observables = addressIds.map((id: string) => this.address.getAddress(id));
        forkJoin(observables).subscribe({
          next: (responses: CustomerAddress[]) => { this.customer.addresses = responses; this.addressesLoading = false; },
          error: () => { this.customer.addresses = []; this.addressesLoading = false; }
        });
      }
    }
    this.breadcrumbService.setItems([this.customerBreadcrumbDefinition, { label: event.data.name },]);
  }
  openDialog(dialogChoice: string, editObject: any = null) {
    switch (dialogChoice) {
      case 'address':
        this.displayAddAddressDialog = true;
        if (editObject) {
          this.newAddressForm.patchValue(editObject);
        }
        this.dialogService.open(AddressDialogComponent, { width: '50vw', data: this.newAddressForm, header: this.translateService.instant('CUSTOMER.ADDRESS.ADDADDRESS'), transitionOptions: this.transitionOption, })
          .onClose.subscribe((addressForm: Address) => {
            this.displayAddAddressDialog = false;
            if (addressForm) {
              if (!editObject) {
                this.newAddressForm.controls.city.setValue(addressForm.city);
                this.newAddressForm.controls.countryCode.setValue(addressForm.countryCode);
                this.newAddressForm.controls.street2.setValue(addressForm.Street2);
                this.newAddressForm.controls.street.setValue(addressForm.street);
                this.newAddressForm.controls.latitude.setValue(addressForm.latitude);
                this.newAddressForm.controls.longitude.setValue(addressForm.longitude);
                this.newAddressForm.controls.zipCode.setValue(addressForm.zipCode);
                this.newAddressForm.controls.id.setValue(null);
                // this.newAddressForm = addressForm;
                this.addAddress();
              } else {
                this.updateAddress(addressForm);
              }
            } else {
              this.newAddressForm.reset();
            }
          });
        break;
      case 'contactPerson':
        this.displayAddContactDialog = true;
        if (editObject) {
          this.newContactForm.patchValue(editObject);
        }
        this.dialogService.open(ContactDialogComponent, {
          width: '50vw',
          data: this.newContactForm,
          header: this.translateService.instant('CUSTOMER.CONTACT.ADD'),
          transitionOptions: this.transitionOption,
        }).onClose.subscribe((contactForm: any) => {
          this.displayAddContactDialog = false;
          if (contactForm) {
            if (!editObject) {
              this.newContactForm = contactForm;
              this.addContact();
            } else {
              this.updateContact(this.newContactForm);
            }
          } else {
            this.newContactForm.reset();
          }
        });
        break;
      case 'customer':
        this.displayNewCustomerDialog = true;
        this.ref = this.dialogService.open(CustomerDialogComponent, {
          width: '50vw',
          data: { customer: this.customer, form: this.newCustomerForm },
          header: this.translateService.instant('NEWCUSTOMER'),
          transitionOptions: this.transitionOption,
          closable: false,
        });

        this.ref.onClose.subscribe((customerForm: any) => {
          this.displayNewCustomerDialog = false;
          if (customerForm) {
            this.newCustomerForm = customerForm;
            this.createCustomer();
          } else {
            this.newCustomerForm.reset();
          }
        });
        break;
      case 'import':
        this.displayImportDialog = true;
        this.ref = this.dialogService.open(ImportCustomerDialogComponent, {
          width: '50vw',
        });
        break;
      default:
        break;
    }
  }

  clearChoice() {
    this.breadcrumbService.setItems([this.customerBreadcrumbDefinition]);
    if (this.customer) {
      this.customer = null;
    }
  }

  onRowUnselect(event: any) {
    this.breadcrumbService.setItems([this.customerBreadcrumbDefinition]);
  }
  onCustomerClick(customer: Customer) {
    this.customer = customer;

    this.tmpCustomerName = customer.name;
    this.tmpCustomerNo = customer.customerNo;
    this.tmpCustomerNote = customer.note;
    this.tmpCustomerServiceCodes = [...(customer.serviceCodes ?? [])];

    if (this.customer.addresses?.length) {
      this.addressesLoading = false;
    } else {
      this.customer.addresses = [];
      this.addressesLoading = true;

      let addressIds = customer.addressIds ?? [];

      if (addressIds.length === 0) {
        this.addressesLoading = false;
      } else {
        let observables = addressIds.map((id: string) =>
          this.address.getAddress(id)
        );

        forkJoin(observables).subscribe({
          next: (responses: CustomerAddress[]) => {
            this.customer.addresses = responses;
            this.addressesLoading = false;
          },
          error: () => {
            this.customer.addresses = [];
            this.addressesLoading = false;
          }
        });
      }
    }

    this.breadcrumbService.setItems([
      this.customerBreadcrumbDefinition,
      { label: customer.name }
    ]);
  }
  get selectedServices(): Service[] {
    return this.clientServices.filter(service =>
      this.tmpCustomerServiceCodes?.includes(service.code)
    );

  }
  removeService(code?: string) {
    if (!code) {
      return;
    }

    this.tmpCustomerServiceCodes =
      this.tmpCustomerServiceCodes.filter(x => x !== code);
  }
  //#endregion

  //#region  Customer

  loadCustomers(refreshSelectedCustomer: boolean = false) {
    this.loading = true;

    let selectedCustomerId = this.customer?.id;

    this.customerService.Customers$.pipe(skip(1), take(1)).subscribe({
      next: (customers) => {
        this.loading = false;
        if (!refreshSelectedCustomer || !selectedCustomerId)
          return;
        let refreshedCustomer = customers.find(c => c.id === selectedCustomerId);

        if (refreshedCustomer) {
          this.customer = refreshedCustomer;
          this.customer.customerAddrses = [];
          this.onCustomerClick(refreshedCustomer);
          // this.onRowSelect({ data: refreshedCustomer });
        } else {
          this.customer = null;
          this.breadcrumbService.setItems([this.customerBreadcrumbDefinition]);
        }
      },
      error: () => {
        this.loading = false;
      },
    });

    this.customerService.getCustomers();
  }

  deleteCustomer(event: any, customer: any) {
    event.stopPropagation();
    event.preventDefault();

    if (!customer.id) {
      return;
    }

    this.confirmationService.confirm({
      message: this.translateService.instant('DELETECONFIRMMESSAGE') + customer.name + '?',
      header: this.translateService.instant('CONFIRMDELETE'),
      icon: 'pi pi-exclamation-triangle',
      key: 'deleteCustomer',
      acceptLabel: this.translateService.instant('GENERIC.YES'),
      rejectLabel: this.translateService.instant('GENERIC.NO'),
      dismissableMask: true,
      accept: () => {
        this.customerService.delete(customer.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('CUSTOMERDELETED'),
            });
            this.loadCustomers(true);
          },
        });
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            break;
          case ConfirmEventType.CANCEL:
            break;
        }
      },
    });
  }
  updateCustomer() {
    this.fullPageLoading = true;
    let customer = {
      id: this.customer.id,
      name: this.tmpCustomerName,
      customerNo: this.tmpCustomerNo,
      note: this.tmpCustomerNote,
      registrationNumber: "",
      serviceCodes: this.tmpCustomerServiceCodes
    } as UpdateCustomer;
    this.customerService.updateCustomer(customer).subscribe({
      next: (customer: Customer) => {
        this.customer.name = this.tmpCustomerName;
        this.customer.customerNo = this.tmpCustomerNo;
        this.customer.note = this.tmpCustomerNote;
        this.fullPageLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('CUSTOMER.UPDATE.SUCCESS'),
        });
        var customers = this.customerService.Customers$.getValue();
        customers.find(x => x.id == customer.id).serviceCodes = this.tmpCustomerServiceCodes
        this.customerService.Customers$.next(customers);
      },
      error: (error) => {
        this.tmpCustomerName = this.customer.name;
        this.tmpCustomerNo = this.customer.customerNo;
        this.fullPageLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('CUSTOMER.UPDATE.ERROR'),
        });
      },
    });
  }
  createCustomer() {
    let customer: CreateCustomer = this.newCustomerForm.value as CreateCustomer;
    let controlls = this.newCustomerForm.controls;
    let customerTypeSafe = {
      customerAddreses: {
        street: controlls.street.value,
        ValidationSource: controlls.validatedBy.value,
        zipCode: controlls.zipCode.value,
        city: controlls.city.value,
        countryCode: controlls.countryCode.value,
        latitude: controlls.latitude.value,
        longitude: controlls.longitude.value,
      },
      name: controlls.name.value,
      contactEmail: controlls.contactEmail.value,
      contactName: controlls.contactName.value,
      note: controlls.note.value,
      customerNo: controlls.customerNo.value,
      contactPhone: controlls.contactPhone.value,
      // sendLabel:controlls.sendLabel.value,
      registrationNumber: controlls.registrationNumber.value,
      serviceCodes: controlls.serviceCodes.value
    } as CreateCustomer;
    customer = customerTypeSafe;

    this.customerService.create(customer).subscribe({
      next: (res) => {
        this.displayNewCustomerDialog = false;
        this.newCustomerForm.reset();

        this.newCustomerForm.controls.latitude.setValue(0);
        this.newCustomerForm.controls.latitude.setValue(0);
        this.loadCustomers(true);
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('CUSTOMER.CREATED.NOTIFICATION'),
          detail: customer.name,
        });
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('CUSTOMER.CREATED.ERROR'),
          detail: error.statusText,
          life: 10000,
        });
      },
    });
  }

  deleteSelectedCustomers(): void {
    if (!this.selectedCustomers?.length) {
      return;
    }

    this.confirmationService.confirm({
      message: this.translateService.instant('DELETECONFIRMMESSAGE'),
      header: this.translateService.instant('CONFIRMDELETE'),
      icon: 'pi pi-exclamation-triangle',
      key: 'deleteCustomer',
      acceptLabel: this.translateService.instant('GENERIC.YES'),
      rejectLabel: this.translateService.instant('GENERIC.NO'),
      dismissableMask: true,
      accept: () => {
        this.fullPageLoading = true;

        const deleteRequests = this.selectedCustomers
          .filter((customer) => !!customer.id)
          .map((customer) => this.customerService.delete(customer.id));

        forkJoin(deleteRequests).subscribe({
          next: () => {
            this.fullPageLoading = false;

            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('CUSTOMERDELETED'),
            });

            this.selectedCustomers = [];
            this.customer = null;

            this.loadCustomers(true);
          },
          error: () => {
            this.fullPageLoading = false;

            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('CUSTOMER.DELETE.ERROR'),
            });
          },
        });
      },
    });
  }
  exportSelectedCustomers(): void {
    if (!this.selectedCustomers?.length) {
      return;
    }

    let customers = this.selectedCustomers;
    this.fullPageLoading = true;

    this.customerService.exportCustomers(customers).subscribe({
      next: (response) => {
        this.fullPageLoading = false;

        const byteCharacters = atob(response.customerDataCSV);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], {
          type: 'text/csv;charset=utf-8;',
        });

        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');

        anchor.href = url;
        anchor.download = 'customers-export.csv';

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.fullPageLoading = false;

        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('CUSTOMER.EXPORT.ERROR'),
        });
      },
    });
  }
  //#endregion

  //#region Addreses
  updateAddress(addressForm: Address) {
    let address: Address = addressForm;
    if (address.id == "")
      address.id = undefined;

    this.customerService.updateCustomerAddress(address, this.customer.id).subscribe({
      next: (res) => {
        this.displayAddAddressDialog = false;
        this.newAddressForm.reset();
        this.newAddressForm.controls['longitude'].setValue(0);
        this.newAddressForm.controls['latitude'].setValue(0);

        this.loadCustomers(true);
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('CUSTOMER.ADDRESS.UPDATED'),
          detail: address.street,
        });
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('CUSTOMER.ADDRESS.ERROR'),
          life: 1000,
        });
      },
    });
  }

  addAddress() {
    let request = {
      customerAddreses: {
        city: this.newAddressForm.controls.city.value,
        countryCode: this.newAddressForm.controls.countryCode.value,
        street: this.newAddressForm.controls.street.value,
        street2: this.newAddressForm.controls.street2.value,
        zipCode: this.newAddressForm.controls.zipCode.value
      } as CustomerAddress,
      customerId: this.customer.id
    } as AddCustomerAddress;

    // let address: AddCustomerAddress = this.newAddressForm.value as AddCustomerAddress;
    // address.customerId = this.customer.id;

    this.customerService.addAddress(request).subscribe({
      next: (res) => {
        this.displayAddAddressDialog = false;
        this.newAddressForm.reset();
        this.newAddressForm.controls.longitude.setValue(0);
        this.newAddressForm.controls.latitude.setValue(0);
        this.loadCustomers(true);
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('CUSTOMER.ADDRESS.ADDED'),
          detail: request.customerAddreses.street,
        });
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('CUSTOMER.ADDRESS.ADDFAILED'),
          detail: error.statusText,
          life: 10000,
        });
      },
    });
  }

  deleteAddress(address: CustomerAddress) {
    this.confirmationService.confirm({
      message: this.translateService.instant('CUSTOMER.ADDRESS.CONFIRMDELETE'),
      header: this.translateService.instant('GENERIC.CONFIRM'),
      icon: 'pi pi-exclamation-triangle',

      accept: () => {
        this.customerService.deleteAddress(address.id, this.customer.id).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'info',
              summary: this.translateService.instant('CUSTOMER.ADDRESS.DELETED'),
            });
            this.loadCustomers(true);
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('CUSTOMER.ADDRESS.ADDFAILED'),
              detail: error.statusText,
              life: 10000,
            });
          },
        });
      },
    });
  }

  deleteSelectedAddresses() {
    this.confirmationService.confirm({
      message: this.translateService.instant('CUSTOMER.ADDRESSES.CONFIRMDELETEMANY'),
      header: this.translateService.instant('GENERIC.CONFIRM'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.selectedAddresses.forEach((address) => {
          this.customerService.deleteAddress(address.id, this.customer.id).subscribe({
            next: (res) => {
              this.messageService.add({
                severity: 'info',
                summary: this.translateService.instant('CUSTOMER.ADDRESS.DELETED'),
              });
              this.loadCustomers(true);
              this.selectedAddresses = [];
            },
          });
        });
      },
    });
  }
  //#endregion

  //#region Contacts
  updateContact(contactPersonForm: any) {
    let contact: CustomerContact = contactPersonForm.value as CustomerContact;
    this.customerService.updateContactPerson(contact, this.customer.id).subscribe({
      next: (res) => {
        this.displayAddContactDialog = false;
        this.newContactForm.reset();
        this.newContactForm.controls['default'].setValue(false);
        this.loadCustomers(true);
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('CUSTOMER.CONTACT.UPDATED'),
          detail: contact.name,
        });
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'CUSTOMER.CONTACT.UPDATEFAILED',
          life: 1000,
        });
      },
    });
  }

  addContact() {
    let contact: CustomerContact = this.newContactForm.value as CustomerContact;

    this.customerService.addContactPerson(contact, this.customer.id).subscribe({
      next: (res) => {
        this.displayAddContactDialog = false;
        this.newContactForm.reset();
        this.newContactForm.controls['default'].setValue(false);
        this.loadCustomers(true);
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('CUSTOMER.CONTACT.ADDED'),
          detail: contact.name,
        });
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('CUSTOMER.CONTACT.ADDFAILED'),
          detail: error.statusText,
          life: 10000,
        });
      },
    });
  }

  deleteSelectedContacts() {
    this.confirmationService.confirm({
      message: this.translateService.instant('CUSTOMER.CONTACT.CONFIRMDELETEMANY'),
      header: this.translateService.instant('GENERIC.CONFIRM'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.selectedContactPersons.forEach((contact) => {
          this.doDeleteContact(contact.id);
        });
      },
    });
  }

  deleteContact(contact: CustomerContact) {
    this.confirmationService.confirm({
      message: this.translateService.instant('CUSTOMER.CONTACT.CONFIRMDELETE'),
      header: this.translateService.instant('GENERIC.CONFIRM'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.doDeleteContact(contact.id);
      },
    });
  }

  doDeleteContact(id: string) {
    this.customerService.deleteContactPerson(id, this.customer.id).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'info',
          summary: this.translateService.instant('CUSTOMER.CONTACT.DELETED'),
        });
        this.loadCustomers(true);
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('CUSTOMER.CONTACT.DELETEFAILED'),
          detail: error.statusText,
          life: 10000,
        });
      },
    });
  }
  //#endregion

}
